import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from './stores/authStore';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import RegistrationsPage from './pages/RegistrationsPage';
import ScreensPage from './pages/ScreensPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import TenantsPage from './pages/TenantsPage';
import SystemInfoPage from './pages/SystemInfoPage';
import SystemSettingsPage from './pages/SystemSettingsPage';
import Loading from './components/Loading';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!authStore.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const App: React.FC = observer(() => {
  useEffect(() => {
    authStore.checkAuth();
  }, []);

  if (authStore.isLoading) {
    return <Loading fullScreen />;
  }

  // rootテナントかどうかを判定
  const isRootTenant = authStore.tenantId === 'root';
  const defaultPath = isRootTenant ? '/tenants' : '/dashboard';

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route
          path="/login"
          element={
            authStore.isAuthenticated ? (
              <Navigate to={defaultPath} replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/forgot-password"
          element={
            authStore.isAuthenticated ? (
              <Navigate to={defaultPath} replace />
            ) : (
              <ForgotPasswordPage />
            )
          }
        />
        <Route
          path="/reset-password"
          element={
            authStore.isAuthenticated ? (
              <Navigate to={defaultPath} replace />
            ) : (
              <ResetPasswordPage />
            )
          }
        />
      </Route>

      <Route
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route path="/" element={<Navigate to={defaultPath} replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/registrations" element={<RegistrationsPage />} />
        <Route path="/screens" element={<ScreensPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        {authStore.isRootAdmin && (
          <>
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/system-info" element={<SystemInfoPage />} />
            <Route path="/system-settings" element={<SystemSettingsPage />} />
          </>
        )}
      </Route>

      <Route path="*" element={<Navigate to={defaultPath} replace />} />
    </Routes>
  );
});

export default App;